// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2rf53","amount":"Amount_amount__1laYK","tip":"Amount_tip__1qRUK","tipHeader":"Amount_tipHeader__2XrSL","tipsWrap":"Amount_tipsWrap__17xXZ"};